import React from "react";
import Checkbox from "@mui/material/Checkbox";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import classes from "./StatusDateInput.module.scss";
import SingleDateField from "../Calendar/SingleDateField";

// ステータス変更ダイアログに置く「今回記録する日付」の欄。
//
// locked=false … 操作者が日付を指定できる(注文日・発注日・取消日)
//   value = { enabled, date }
//     enabled=false … その日付は変更しない(未設定の注文にだけ現在時刻が入る)
//     enabled=true  … 指定した日付で上書きする(時刻は既存値を維持)
//
// locked=true … 日付を指定させない(検収日)
//   給与控除は検収日で月を締めるため、締めた月へ遡って登録できると控除漏れになる。
//   入力欄の代わりに「何が記録されるか」を読み取り専用で見せる。
//   ※ 入力欄を消すだけでなく functions/order/orderDateUpdate.js 側でも
//     指定値を無視しているので、ここは表示の責務だけを持つ。
//
// 既定値の決め方は functions/order/orderDateUpdate.js の getDefaultDateInput を、
// 文言は functions/order/orderDateMessages.js を参照。
const StatusDateInput = ({ label, value, onChange, hint, locked, notice }) => {
  const enabled = !!value?.enabled;
  // locked は呼び出し側からも渡せるが、既定は getDefaultDateInput が
  // dateInput に載せてくる locked を使う。
  // 画面側が渡し忘れてもカレンダーが出てしまわないようにするため。
  const isLocked = locked ?? !!value?.locked;

  const handleToggle = (event) => {
    onChange({ ...value, enabled: event.target.checked });
  };

  const handleDateChange = (date) => {
    onChange({ ...value, date });
  };

  if (isLocked) {
    return (
      <div className={classes.root}>
        <div className={classes.lockedHead}>
          <LockOutlinedIcon className={classes.lockIcon} />
          <span className={classes.lockedLabel}>{`${label}は自動で記録されます`}</span>
        </div>
        {notice && <div className={classes.lockedNotice}>{notice}</div>}
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <label className={classes.toggle}>
        <Checkbox
          size="small"
          checked={enabled}
          onChange={handleToggle}
          inputProps={{ "aria-label": `${label}を更新する` }}
        />
        <span className={classes.toggleLabel}>
          {label}を次の日付に更新する
        </span>
      </label>
      <div className={classes.field}>
        <SingleDateField
          label={label}
          value={value?.date ?? null}
          onChange={handleDateChange}
          disabled={!enabled}
          width={160}
        />
      </div>
      {hint && <div className={classes.hint}>{hint}</div>}
    </div>
  );
};

export default StatusDateInput;
